import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { paymentApi } from 'api'

import { Spinner } from 'components/Spinner'

const StripePage = (props) => {
  const [connectLink, setConnectLink] = useState('')
  const locationState = props.location.state

  useEffect(() => {
    locationState === '0' || !locationState
      ? paymentApi
          .createSubscription()
          .then((res) => setConnectLink(res.result.action_url))
      : paymentApi.connectStripe().then((res) => setConnectLink(res.result.action_url))
  }, [locationState])

  useEffect(() => {
    if (connectLink) {
      // Keep browser back from Stripe pointed at pro signup instead of the transient handoff route.
      window.history.replaceState(null, '', '/pro/signup')
      window.location.assign(connectLink)
    }
  }, [connectLink])

  useEffect(() => {
    document.title = 'TalkPro | Connect Payment'
  }, [])

  return (
    <section className="section">
      <Spinner />
    </section>
  )
}

const mapStateToProps = ({ auth: { user } }) => ({
  user,
})

export default connect(mapStateToProps)(StripePage)
